import { makeCommsPage } from './commsPage'
import { CommsMailboxWorkspaceView } from '../components/views/commsMailboxWorkspaceView'

export default makeCommsPage({
    title: 'Mailbox',
    probeUrl: 'comms/mailboxes/list',
    View: CommsMailboxWorkspaceView,
    className: 'commsMailboxWorkspace',
    viewRendersHeader: true,
})
